import axios from 'redaxios'
import { config } from '../constants'
import { Locale } from './locale'

export class AdditionalTypes {
  static instance: AdditionalTypes
  static getInstance() {
    if (!AdditionalTypes.instance) {
      AdditionalTypes.instance = new AdditionalTypes()
    }
    return AdditionalTypes.instance
  }

  list: any = []
  tree: any = {}
  initializing: boolean = false

  constructor() {
    this.init()
  }

  public isReady() {
    return this.list.length > 0
  }

  async init() {
    if (this.initializing) {
      await new Promise(resolve => {
        let interval = setInterval(() => {
          if (!this.initializing) {
            clearInterval(interval)
            resolve(true)
          }
        }, 100)
      })

      return
    }

    this.initializing = true
    const response = await axios.get(`${config.backendApi}/content/getAdditionalTypes`)
    this.list = response.data.list
    this.tree = response.data.tree
    this.initializing = false
  }

  async getCategories(addFlagged: boolean = false) {
    if (!this.isReady()) {
      await this.init()
    }

    let list: any = []

    for (let k in this.tree) {
      for (let i = 0; i < this.list.length; i++) {
        if (`${this.list[i].id}` === `${k}`) {
          list.push(this.list[i])
          break
        }
      }
    }

    if (addFlagged) {
      let flagged = await this.getFlagged()
      list.push(...flagged)
    }

    return this.toLocale(list)
  }

  async getFlagged() {
    if (!this.isReady()) {
      await this.init()
    }

    //@TODO move this to backend when ready
    let additionalTypes = [
      'V1UITaxoDVitrine_UI-D-VisitesGuidAnim',
      'V1UITaxoDVitrine_UI-D-Conference',
    ]
    let list: any = []

    for (let i = 0; i < this.list.length; i++) {
      if (additionalTypes.indexOf(this.list?.[i]?.additionalTypeIdVitrine ?? 'NONE') > -1) {
        list.push(this.list[i])
      }
    }

    return list
  }

  async getSubCategories(id: any) {
    if (!this.isReady()) {
      await this.init()
    }

    let list: any = []

    if (!this.tree[`${id}`]) {
      return []
    }

    for (let k = 0; k < this.tree[`${id}`].length; k++) {
      for (let i = 0; i < this.list.length; i++) {
        if (`${this.list[i].id}` === `${this.tree[`${id}`][k]}`) {
          list.push(this.list[i])
          break
        }
      }
    }

    return this.toLocale(list)
  }

  async getSubCategoriesBySlug(slug: string) {
    let category = await this.getAdditionalTypeBySlug(slug)
    if (!category) {
      return []
    }
    return this.getSubCategories(category.id)
  }

  async getAllInTree(addFlaged: boolean = false) {
    if (!this.isReady()) {
      await this.init()
    }
    let categories = await this.getCategories(addFlaged)

    for (let i = 0; i < categories.length; i++) {
      categories[i].children = await this.getSubCategories(categories[i].id)
    }

    return categories
  }

  async getAll() {
    if (!this.isReady()) {
      await this.init()
    }
    return this.toLocale(this.list)
  }

  toLocale(list: any[]) {
    let k = Locale.getInstance().getLanguage() === 'en' ? 'labelEn' : 'labelFr'
    return list.map((item: any) => {
      let label = item[k]
      if (label) {
        let labelSplit = label.split('>')
        label = labelSplit[labelSplit.length - 1].trim()
      }

      return {
        ...item,
        label,
      }
    })
  }

  async getListAdditionalTypeBySlug(slugList: string[]): Promise<any[]> {
    if (!this.isReady()) {
      await this.init()
    }

    let list: any[] = []

    for (let i = 0; i < slugList.length; i++) {
      let item = await this.getAdditionalTypeBySlug(slugList[i])

      if (item) {
        list.push(item)
      }
    }

    return this.toLocale(list)
  }

  async getAdditionalTypeBySlug(slug: string): Promise<any> {
    if (!this.isReady()) {
      await this.init()
    }

    for (let i = 0; i < this.list.length; i++) {
      if (`${this.list[i].code}` === `${slug}`) {
        return this.list[i]
      }
    }

    return null
  }

  async getAdditionalType(id: any) {
    if (!this.isReady()) {
      await this.init()
    }

    for (let i = 0; i < this.list.length; i++) {
      if (`${this.list[i].id}` === `${id}`) {
        return this.list[i]
      }
    }
  }
}
